/* ShopShip speed layer
   1. A progress bar starts the moment a link is tapped.
   2. Prerender product/collection pages as soon as a finger touches a link.
   (Gallery, cart and section reveals live in theme.js / premium.css.) */
(function () {
  "use strict";

  // Thin progress bar the instant a link is tapped (page swap feels immediate).
  function initNavBar() {
    var bar = document.createElement("div");
    bar.className = "nav-bar";
    document.body.appendChild(bar);
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest("a[href]");
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === "_blank" || a.hasAttribute("download")) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin || (url.pathname === location.pathname && url.hash)) return;
      bar.classList.remove("is-on"); void bar.offsetWidth; bar.classList.add("is-on");
    });
    window.addEventListener("pageshow", function () { bar.classList.remove("is-on"); });
  }

  // Prerender product and collection pages on touch/press, so they open instantly.
  function initPrerender() {
    if (!HTMLScriptElement.supports || !HTMLScriptElement.supports("speculationrules")) return;
    var rules = document.createElement("script");
    rules.type = "speculationrules";
    rules.textContent = JSON.stringify({
      prerender: [{
        source: "document",
        where: { and: [
          { href_matches: ["/products/*", "/collections/*"] },
          { not: { href_matches: ["/*?*add*", "/cart*", "/checkout*"] } },
          { not: { selector_matches: "[rel~=nofollow], [target=_blank]" } }
        ] },
        eagerness: "conservative"
      }]
    });
    document.head.appendChild(rules);
  }

  function init() {
    initNavBar();
    initPrerender();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
